import { useUrlOpenState } from '@wwe-portal/web/hooks/common/use-url-params';
import {
  ModalPriority,
  usePriorityModal,
} from '@wwe-portal/web/providers/stores/priority-dialog-store';

export const useStepupModalOpen = () => {
  const [open, setOpen] = useUrlOpenState({
    defaultValue: {
      stepupModal: null,
    },
    paramName: 'stepupModal',
  });

  const { visible } = usePriorityModal({
    id: 'stepupModal',
    priority: ModalPriority.STEPUP,
    open,
  });

  return [visible, setOpen] as const;
};
